export const environment = {
  production: true,
  apiHost: 'https://hs1.hsbooster.eu/',
  apiUrl: 'https://api.hsbooster.eu',
};
